export default __webpack_public_path__ + "static/media/starsBg.c313aa7f.svg";